<template>

    <div class="outer-wrapper" v-if=" uiSuccess ">

        <font-awesome-icon class="success-icon" icon="check-circle" :style="{ color: iconColor }"/>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';
    import FontAwesomeIcon from '@fortawesome/vue-fontawesome';

    export default {

        name: 'ui-success',
        data: function() {

            return {

                iconColor : 'lime',
                colors    : [ 'red', 'orange', 'yellow', 'lime', 'green', 'purple', 'blue', 'cyan', 'pink' ],
                interval  : null,
                current   : 0
            }
        },
        computed: {

            ...mapGetters({

                uiSuccess : 'uiSuccess'
            })
        },
        methods: {

            chooseColor(){

                this.iconColor = this.colors[ Math.floor( Math.random() * this.colors.length ) ];
            }
        },
        created(){

            var _this = this;
            this.interval = setInterval( () => {

                _this.chooseColor();
            }, 150 );
        },
        destroyed(){

            clearInterval( this.interval );
        },
        components: {

            FontAwesomeIcon
        }
    }
</script>

<style scoped>

    .outer-wrapper {

        position: fixed;
        top: 40%;
        left: 40%;
        z-index: 550;
    }
    .success-icon {

        font-size: 80px;
        z-index: 550;
        background-color: white;
        border-radius: 50%;
        transition: color 0.5s ease;
    }
</style>

